
import { Component, Vue } from 'vue-property-decorator'
import { login } from '../../utils/user'
import '../../scss/base.scss'
import secret from '../../utils/secret'
import rsaSecret from '../../utils/rsaSecret'

@Component
export default class Login extends Vue {
  // title = '系统登录'
  ischeck=false
  loginForm = { username: '', password: '' }
  loginRules = {
    username: [{ required: true, message: '用户名不能为空', trigger: 'blur' }],
    password: [{ required: true, message: '密码不能为空', trigger: 'blur' }]
  }
  passwordType = 'password'

  mounted() {}


  async handleLogin() {
    this.$refs['loginForm']
    let isPass = false
    //登录信息校验
    await (this.$refs['loginForm'] as any).validate((valid: boolean) => {
      isPass = valid
    })
    if (!isPass) {
      console.log('用户名或者密码没有填写')
      return
    }

    var loginParams = Object.assign({},this.loginForm)
     //使用AES加密
     let aesPs = secret.encrypt(loginParams.password)
    //使用rsa加密
    let rsaPs = rsaSecret.encrypt(aesPs)

    loginParams.password = rsaPs
    loginParams.username = this.loginForm.username

    login(loginParams)
      .then((response: any) => {
        // console.log("登录请求后接收到的所有信息",response)
        var user = response.data
        this.$store.commit('setToken', user.token)
        // this.$store.commit('updateUser', response.data)

        var patrn = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,18}$/;
        if (response.data.type !== 1 && !patrn.exec(this.loginForm.password)) {
          this.$router.push('/login/initpassword')
          // this.$store.commit('logout')
          return
        }
        if (response.data.type == 1 && !patrn.exec(this.loginForm.password)) {
          this.$router.push('/login/initpassword2')
          // this.$store.commit('logout')
          return
        }

        if (response.data.islogin === '1') {
          this.$store.commit('logout')
          this.$router.push('/bjba')
          return
        }
        this.saveLog(response.data)
        sessionStorage.setItem("triman_bsrkapp_store", JSON.stringify(this.$store.state))
        if (response.data.type === 1) this.$router.push('/customer')
        else this.$router.push('/bjba')
      })

      .catch(error => {
        console.log("error:",error.response.data.msg);
        this.$message.error(error.response.data.msg)
      })
  }
  saveLog(logParams: any) {
    // console.log("传入的参数为：",logParams)
    var params = {
      userid: logParams.userId,
      zydm: logParams.username,
      zyxm: logParams.name,
      bmid: logParams.zzdyqc,
      lsbmmc: logParams.zzdyqcmc,
      dlsj: this.getNowTime(),
      type: logParams.type==1 ? '3' : '1'
    }
    // console.log("要保存的登录日志信息为：",params)
    this.$request({
        url: '/user/logIn',
        method: 'post',
        data:params
    }).then((response: any)=>{
        // console.log("保存日志返回信息",response);
    }).catch((err: any)=>{
        console.log(err)
    });
  }
  getNowTime(){
    var myDate = new Date();
    var year = myDate.getFullYear();
    var month = myDate.getMonth()+1;
    var date = myDate.getDate();
    var h = myDate.getHours();
    var m = myDate.getMinutes();
    var s = myDate.getSeconds();
    var now = year + '-' +(month < 10 ? "0" :"")+ month + "-"+((date < 10 ? "0" :"")) +date + " "+((h < 10 ? "0" :"")) + h + ':'+((m < 10 ? "0" :"")) + m + ":"+((s < 10 ? "0" :"")) + s;
    console.log('登陆时间',now)
    return now;
  }
  logout() {
    this.$store.commit('logout')
  }
  showPwd() {
    if (this.passwordType === 'password') {
      this.passwordType = ''
    } else {
      this.passwordType = 'password'
    }
  }
}
